import { create } from 'zustand';

interface SiteImportUIState {
  activeStep: number;
  importPath: 'template' | 'csv' | null;
  showCancelConfirm: boolean;
}

interface SiteImportUIActions {
  setActiveStep: (step: number) => void;
  nextStep: () => void;
  previousStep: () => void;
  setImportPath: (path: 'template' | 'csv' | null) => void;
  setShowCancelConfirm: (show: boolean) => void;
  resetNavState: () => void;
}

export const useSiteImportUIStore = create<
  SiteImportUIState & SiteImportUIActions
>(set => ({
  activeStep: 0,
  importPath: null,
  showCancelConfirm: false,

  setActiveStep: (step: number) => set({ activeStep: step }),

  nextStep: () => set(s => ({ activeStep: s.activeStep + 1 })),

  previousStep: () => set(s => ({ activeStep: Math.max(0, s.activeStep - 1) })),

  setImportPath: (path: 'template' | 'csv' | null) => set({ importPath: path }),

  setShowCancelConfirm: (show: boolean) => set({ showCancelConfirm: show }),

  resetNavState: () =>
    set({ activeStep: 0, importPath: null, showCancelConfirm: false }),
}));
